import { extractCurrentFields } from "./";
import sumBy from "lodash/sumBy";
import toNumber from "lodash/toNumber";

export function computePrice(product, userCount = 1) {
  const { value = 0, unit, deposit = 100, perPerson } = product.price || {};
  if (perPerson) {
    return toNumber(value) * userCount;
  }
  return toNumber(value);
}

export function computeDeposit(product, userCount) {
  const { deposit = 100 } = product.price || {};
  return Math.floor((computePrice(product, userCount) * toNumber(deposit)) / 100);
}

export function getCheckedProducts(form, data, userCount) {
  const fields = extractCurrentFields(form, data);
  // console.log("fields", fields);
  const productFields = fields.filter(f => f.type === "ProductField");
  const selectedProducts = productFields.filter(p => p.forceValue || data[p.name]);
  const products = selectedProducts.filter(p => !p.price.percentage);
  const extras = selectedProducts.filter(p => !!p.price.percentage);

  // Compute amounts
  const productsWithAmount = products.map(p => ({
    ...p,
    amount: computePrice(p, userCount),
    depositAmount: computeDeposit(p, userCount)
  }));

  // Add percentages
  const total = sumBy(productsWithAmount, "amount");
  // console.log("total", total);
  const extrasWithAmount = extras.map(p => {
    const { deposit = 100 } = p.price || {};
    const amount = Math.floor((p.price.percentage * total) / 100);
    const depositAmount = Math.floor((amount * toNumber(deposit)) / 100);
    return {
      ...p,
      amount,
      depositAmount
    };
  });

  // Compute recap and infos...
  return { products: productsWithAmount, extras: extrasWithAmount };
}

export function getTotalPrice(form, data, userCount) {
  const products = getCheckedProducts(form, data);
  return sumBy(products, p => computePrice(p, userCount));
}

export function getDepositPrice(form, data, userCount) {
  const products = getCheckedProducts(form, data);
  return sumBy(products, p => computeDeposit(p, userCount));
}

// TODO : broken, remove ??
export function getPrices(form, data, userCount = 1) {
  const products = getCheckedProducts(form, data);
  return {
    total: sumBy(products, p => computePrice(p, userCount)),
    deposit: sumBy(products, p => computeDeposit(p, userCount))
  };
}
